import {
  Button,
  Dialog,
  DialogActions,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import React, { useState } from "react";

const ReportModal = ({
  open,
  handleClose,
  closedBusiness = false,
  title = "Member Activity Report",

  type = "",
  data = {},
  showAllTime = false,
  generalClosedBusiness = false,
  overallActivity = false,
}) => {
  const [timeframe, setTimeframe] = useState(
    dayjs().subtract(1, "year").format("YYYY-MM-DD"),
  );
  const handleSubmit = () => {
    if (closedBusiness) {
      const reportTypes =
        type === "both"
          ? ["sent", "received"]
          : Array.isArray(type)
            ? type
            : [type];
      window.open("/closed-business-report");
      localStorage.setItem("closedBusinessReport", timeframe);
      localStorage.setItem(
        "closedBusinessReportType",
        JSON.stringify(reportTypes),
      );
      localStorage.setItem(
        "closedBusinessReportTitle",
        `${data?.first_name} ${data?.last_name}`,
      );
      localStorage.setItem("memberId", data?.id);

      handleClose();
    }
    if (generalClosedBusiness) {
      window.open("/general-closed-business-report");
      localStorage.setItem("generalClosedBusinessReport", timeframe);
      handleClose();
    }

    if (overallActivity) {
      window.open("/overall-activity-report");
      localStorage.setItem("overallActivityReport", timeframe);
      handleClose();
    }

    window.open("/member-activity-report");
    localStorage.setItem("report", timeframe);
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-modal"
      sx={{
        ".MuiPaper-root": {
          width: "411px",
        },
      }}
    >
      <div className="modal-header">
        <h2 className="header-text">{title}</h2>
        <IconButton onClick={() => handleClose()}>
          <GridCloseIcon />
        </IconButton>
      </div>
      <Grid
        container
        spacing={2}
        rowSpacing={2.5}
        sx={{
          padding: "16px 0",
        }}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            fullWidth
            id="status"
            label="Period for Report*"
            name="status"
            value={timeframe}
            onChange={(e) => {
              setTimeframe(e.target.value);
              // setIsLoading(true);
            }}
            className="login-textField "
            size="small"
            select
          >
            <MenuItem value={dayjs().subtract(1, "year").format("YYYY-MM-DD")}>
              1 year
            </MenuItem>
            <MenuItem value={dayjs().subtract(6, "month").format("YYYY-MM-DD")}>
              6 months
            </MenuItem>
            <MenuItem value={dayjs().subtract(3, "month").format("YYYY-MM-DD")}>
              3 months
            </MenuItem>
            <MenuItem value={dayjs().subtract(1, "month").format("YYYY-MM-DD")}>
              1 months
            </MenuItem>
            {showAllTime && <MenuItem value="all">All Time</MenuItem>}
          </TextField>
        </Grid>
      </Grid>

      <DialogActions className="modal-btn-container">
        <Button onClick={handleClose} className="button-common light-blue-bg">
          Cancel
        </Button>
        <Button onClick={handleSubmit} className="add-new-button button-common">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportModal;
